import { createPinia } from "pinia" //引入pinia
 
const pinia = createPinia() //创建pinia实例
 
export default pinia //导出pinia用于main.js注册